import { createBaseApi } from '../utils/createBaseApi';
import { Tags } from './tagTypes';

export const [mainApi, initMainApi] = createBaseApi({
  name: 'mainApi',
  tagTypes: Tags,
  endpoints: () => ({}),
});
